import React, {useEffect, useState} from 'react';
import {getProductGroup} from "../api/HomeApi";
import {BiCategoryAlt} from "react-icons/bi";
import {TiChevronLeftOutline} from "react-icons/ti";
import {IoMdArrowDropleft} from "react-icons/io";
import {useNavigate, useParams} from "react-router-dom";
import Loading from "../../../layouts/Loading";
import {showError} from "../../../utils/toastHelper";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';


const ProductGroupsSlide = () => {
    const [productGroups, setProductGroups] = React.useState([]);
    const [loading, setLoading] = useState(false);
    const {id} = useParams();
    const navigate = useNavigate();
    const config = window.APP_CONFIG;

    useEffect(() => {
        const fetchGroups = async () => {
            try {

                const params = {
                    count:  config.shopping_app_settings.product_group_count,
                    special: true,
                    list: 1,
                    parent_id : id
                }
                const data = await getProductGroup(params);
                setProductGroups(data?.data || []);
            } catch (err) {
                 showError( err);
            } finally {
                setLoading(false);
            }
        };
        fetchGroups();
    }, [id]);



    if (loading) return <Loading />;

    return (

    <section className="container  mt-4  rtl px-0  ">

            <div className="row mx-1">
                <div className="col-8 home-separator-text ">
                    <BiCategoryAlt className='mx-2'/>

                    دسته بندی ها
                </div>
                <div className="col-4 text-start text-small-3 text-secondary-color mt-1"
                     onClick={
                         () => {
                             navigate(`/categories`)
                         }
                     }
                >
                    مشاهده همه
                    <TiChevronLeftOutline className='mx-1'/>
                </div>
            </div>


        <div className="row mx-2 mt-3 mb-5 product-group-slide">

            <Swiper
                spaceBetween={10}
                slidesPerView="auto"
                style={{ paddingBottom: '10px' }}
            >
                {productGroups.map((group) => (
                    <SwiperSlide key={group.id} style={{ width: 'auto' }}>
                        <div
                            className='category-slide'
                            onClick={
                                () => {
                                    group.sub_categories > 0 ?
                                        navigate(`/categories/${group.id}`) :
                                        navigate(`/products/${group.id}`)
                                }
                            }
                        >

                            {group.name.substring(0, 20)}
                            {
                                group.name.length > 20 ?
                                    <span className='text-small-4'>
                                                    ...
                                                </span>
                                    : ''
                            }
                            {
                                group.sub_categories > 0 &&
                                <span>
                                                <IoMdArrowDropleft  />
                                            </span>
                            }
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            {


            }

        </div>

    </section>
    );
};

export default ProductGroupsSlide;